var map = {
	"./ASSCHER.png": "./src/assets/stone_shape/ASSCHER.png",
	"./CUSHION.png": "./src/assets/stone_shape/CUSHION.png",
	"./EMERALD.png": "./src/assets/stone_shape/EMERALD.png",
	"./HEART.png": "./src/assets/stone_shape/HEART.png",
	"./MARQUISE.png": "./src/assets/stone_shape/MARQUISE.png",
	"./OLD MINER CUT.png": "./src/assets/stone_shape/OLD MINER CUT.png",
	"./OVAL.png": "./src/assets/stone_shape/OVAL.png",
	"./PEAR.png": "./src/assets/stone_shape/PEAR.png",
	"./PRINCESS.png": "./src/assets/stone_shape/PRINCESS.png",
	"./RADIANT.png": "./src/assets/stone_shape/RADIANT.png",
	"./ROUND.png": "./src/assets/stone_shape/ROUND.png",
	"./SHIELD.png": "./src/assets/stone_shape/SHIELD.png",
	"./TRIANGULAR.png": "./src/assets/stone_shape/TRIANGULAR.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/stone_shape sync recursive ^\\.\\/.*\\.png$";